import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { installZoomOverrideHelper } from './lib/zoomConfig';
import { ensureZoomSdkScript } from './lib/zoomSdk';
import './styles.css';

installZoomOverrideHelper();
ensureZoomSdkScript();

const el = document.getElementById('root');
if (!el) {
  throw new Error('Root element #root not found');
}

createRoot(el).render(
  <StrictMode>
    <App />
  </StrictMode>
);
